import React from 'react';
import styled from 'styled-components';

class ListContent extends React.Component {
  render() {
    return (
      <ul style={{listStyleType: this.props.primary ? 'initial' : 'none', paddingLeft: this.props.primary ? '40px' : '20px'}}>
        {this.props.items.map(name => <li key={name}>{name}</li>)}
      </ul>
    );
  }
}

export default ListContent;


// WEBPACK FOOTER //
// ./src/components/ListContent.js